module.exports = {
	"pt": {
		"credentials": {}
	}
};